const { RichText } = wp.blockEditor;
const Save = ({ attributes }) => {
  const {
    cardButtonHref,
    descriptionCard,
    numberCard,
    textCard,
    icon,
    cardHasImg,
    cardHasDescription,
    background,
    variant,
  } = attributes;

  return (
    <div
      className={`ColorCardsItem ${variant}  ${
        variant === 'text-inside' ? background : ''
      }`}
    >
      <a className={`ColorCardsItem__card`} href={cardButtonHref}>
        <div
          className={`ColorCardsItem__card--content  ${
            variant === 'text-outside' ? background : ''
          }`}
        >
          {cardHasImg ? (
            icon.src && (
              <figure className="ColorCardsItem__card--icon">
                <img src={icon.src} alt={icon.alt} />
              </figure>
            )
          ) : (
            <div className="ColorCardsItem__card--text">
              <RichText.Content
                tagName="p"
                value={numberCard}
                className="ColorCardsItem__card--number"
              />
              <RichText.Content
                tagName="p"
                value={textCard}
                className="ColorCardsItem__card--underNumber"
              />
            </div>
          )}
        </div>

        {cardHasDescription && (
          <RichText.Content
            tagName="p"
            value={descriptionCard}
            className={`ColorCardsItem__card--description Typography subtitle color-blue center margin-none`}
          />
        )}
      </a>
    </div>
  );
};

export default Save;
